import {ZIDX, ZIDXPage} from "../../../../standalone/standaloneLibrary.js";

export class ZIDXAccountMlsGridServers implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountMlsGridServersContainer";
    }
    render(){
        // console.log("mls grid server logins");
    }
}